<template>
  <v-card :class="[screenType !== 'desktop' && 'wrapper-mobile']">
    <v-card-title class="bg-grey fs-1-5r" v-if="screenType === 'desktop'">
      <span tabindex="0"
        >{{ $t('Results') }}
        {{ loggedUser.role === 'Individual' ? 'and Downloading' : '' }}</span
      >
    </v-card-title>

    <v-card-text
      class="pa-1 session-report-wrapper pa-2 d-flex flex-column"
      :class="[
        accessibility.isStrongColors && 'strong-colors',
        language === 'he' ? 'dir-rtl' : 'dir-ltr',
        screenType === 'desktop'
          ? 'font-size-16'
          : 'font-size-14 session-report-wrapper-mobile',
      ]"
      tabindex="0"
    >
      <div class="fill-height d-flex flex-column overflow-auto flex-grow-1">
        <div class="d-flex flex-column overflow-auto">
          <!--START TIME-->
          <span class="my-1"
            ><b>{{ $t('Started') }}:</b>
            {{ statusResults.session.startTime }}</span
          >

          <!--END TIME-->
          <span v-if="statusResults.session.duration" class="my-1"
            ><b>{{ $t('Duration') }}:</b>
            {{ statusResults.session.duration | parseTime }} (mm:ss)</span
          >

          <!--SIZE-->
          <span class="my-1"
            ><b>{{ $t('Size') }}:</b>
            {{ statusResults.session.freezedTotalSize | bytesToSize }}</span
          >

          <!--ROUTE-->
          <span
            v-if="
              loggedUser.organizationId !== 0 &&
              statusResults.session.selectedRoute?.name
            "
            class="my-1"
            ><b>{{ $t('Route') }}:</b>
            {{ statusResults.session.selectedRoute?.name }}</span
          >

          <div
            v-for="item of statusResults.session.interfaceDynamicFields?.filter(
              el => el.value
            )"
            class="flex-grow-1"
          >
            <span v-if="loggedUser.role !== 'Individual'" class="my-1"
              ><b>{{ item.textToDisplay }}:</b> {{ item.value }}
            </span>
          </div>

          <!--SENT TO REGISTERED-->
          <div
            v-if="
              loggedUser.organizationId !== 0 &&
              statusResults.session.selectedUsers?.length > 0
            "
            class="my-1 flex-grow-1 overflow-auto addresses-wrapper"
          >
            <b>{{ $t('Sent to registered accounts') }}:</b>

            <ul>
              <li v-for="user of statusResults.session.selectedUsers">
                {{ user }}
              </li>
            </ul>
          </div>

          <!--SENT TO CASUALS-->
          <div v-if="isShowSentToCasuals" class="my-1">
            <!--IF THE USER DIDNT SENT TO CASUAL USERS-->
            <b>{{ $t('Sent to guests') }}:</b>
            <ul>
              <li v-for="user of statusResults.session.selectedCasualUsers">
                {{ user }}
              </li>
            </ul>
          </div>
        </div>

        <template v-if="statusResults.intact && loggedUser.isAllowReport">
          <v-divider class="my-1" />
          <!--REPORT-->
          <div class="my-2 d-flex justify-space-between">
            <!--SUMMARY-->
            <div>
              <div class="mb-2 font-weight-bold">
                {{ $t('Transference Report') }}
              </div>
              <Summary
                :screenType="screenType"
                :statusResults="statusResults"
              />
            </div>

            <v-divider vertical class="mt-1"></v-divider>
            <!--FULL REPORT BUTTON-->
            <div class="d-flex flex-column align-center justify-center ml-1">
              <!--SHOW FULL REPORT-->
              <Button
                :clickAction="() => (isShowFullReport = !isShowFullReport)"
                :text="`${screenType === 'desktop' ? isShowFullReport ? $t('Hide') : $t('Show') : $t('Show')} ${$t(
                  'Filtering Report'
                )}`"
                :width="screenType === 'desktop' ? '220' : '125'"
                class="my-1"
                :class="[screenType === 'desktop' && 'mx-2']"
                :height="screenType === 'desktop' ? '25' : '50'"
                :btnSize="'medium'"
                :wrapText="true"
              />

              <!--DOWNLOAD REPORT-->
              <Button
                :clickAction="downloadReportClicked"
                :text="$t('Download Filtering Report')"
                :width="screenType === 'desktop' ? '220' : '125'"
                :height="screenType === 'desktop' ? '25' : '50'"
                :btnSize="'medium'"
                class="my-1"
                :class="[screenType === 'desktop' && 'mx-2']"
                :wrapText="true"
              />
            </div>
          </div>
        </template>
        <!--REPORT ITSELF-->
        <div
          v-if="isShowFullReport && screenType === 'desktop'"
          v-html="statusResults.session.htmlReport.summary"
          class="wrapper-2 ma-2"
          style="max-height: 600px; overflow: auto; direction: ltr"
        ></div>
        <div v-if="isShowFullReport && screenType !== 'desktop'">
          <ReportHtmlDialog
          :closeDialog="() => (isShowFullReport = false)"
            :htmlReport="statusResults.session.htmlReport.summary"
          />
        </div>
      </div>
    </v-card-text>

    <div v-if="loggedUser.role === 'Individual' || screenType === 'desktop'">
      <v-divider />

      <!--BUTTON-->
      <div class="d-flex pa-4 justify-space-between fill-width">
        <!--INDIVIDUAL DOWNLOAD FILES-->
        <Button
          v-if="loggedUser.role === 'Individual'"
          :clickAction="downloadIndividualFiles"
          text="Download Filtered Files"
          class="mx-2"
        />
        <div v-else></div>
        <!--CANCEL-->
        <Button
          v-if="screenType === 'desktop'"
          :clickAction="restartSessionClicked"
          :text="$t('Close')"
          btnType="grey"
          width="100"
          class="mx-2"
        />
      </div>
    </div>
  </v-card>
</template>
<script>
import { parseTime, bytesToSize } from '@/utils'
import { mapGetters } from 'vuex'
import {
  DownloadReport,
  downloadFilesIndividual,
} from '../../../Websiteinterface'

//Base Components
import Button from '@/components/BaseComponents/Button/Button.vue'
import Summary from '@/components/BaseComponents/Summary/Summary.vue'

import DynamicFieldsDialog from '@/components/WebsiteInterface/CommonComponents/DynamicFieldsDialog/DynamicFieldsDialog.vue'
import ReportHtmlDialog from './ReportHtmlDialog.vue'

export default {
  name: 'UploadReportDialog',
  data() {
    return {
      dialog: true,
      isShowFullReport: false,
      fullReport: null,
    }
  },
  components: { Button, Summary, DynamicFieldsDialog, ReportHtmlDialog },
  props: {
    restartSessionClicked: Function,
    statusResults: Object,
    screenType: String,
  },
  filters: {
    parseTime,
    bytesToSize,
  },
  computed: {
    ...mapGetters([
      'accessibility',
      'loggedUser',
      'isDarkMode',
      'language',
      // 'interactiveInterfaceFields',
    ]),
    isShowSentToCasuals() {
      if (this.loggedUser.role === 'SuperAdmin') return false
      else if (this.loggedUser.role === 'Individual') return false
      else if (this.statusResults.session.selectedCasualUsers?.length === 0)
        return false
      // else if (this.loggedUser.isOrgHasCasuals) return true
      return true
    },
  },
  methods: {
    async downloadReportClicked() {
      DownloadReport(this.statusResults.session.htmlReport)
    },
    downloadIndividualFiles() {
      downloadFilesIndividual(this, this.statusResults.session.operationId)
    },
  },
}
</script>

<style scoped src="../UploadReportDialog.css"></style>
